export default `
    .MuiDataGrid-scrollbar, .MuiDataGrid-filler {
        display: none !important;
    }
                        
    .MuiDataGrid-root, .MuiDataGrid-mainContent, .MuiDataGrid-virtualScroller, .MuiDataGrid-virtualScrollerContent {
        flex: none !important;
        height: 0px !important;
        min-height: 0px !important;
        overflow: visible !important;
        border: 0px !important;
    }
                                             
    .MuiDataGrid-virtualScrollerRenderZone {
        border-top: none;       
    }
    
    .MuiDataGrid-columnHeaders {
        border: 2px solid var(--DataGrid-t-color-border-base);
        border-bottom: none;
    }
    
    .MuiDataGrid-row {
        border-left: 1px solid var(--DataGrid-t-color-border-base);
        border-right: 1px solid var(--DataGrid-t-color-border-base);
    }
    
    .MuiDataGrid-virtualScrollerRenderZone:last-child {
        border-bottom: 2px solid var(--DataGrid-t-color-border-base);
    }
`
